import React, { useEffect, useRef } from 'react';

function ScheduleModal({ isOpen, onClose, viewMode, selectedDate, todoText, setTodoText, onAdd }) {
  const inputRef = useRef(null);

  // 모달이 열릴 때 input 창에 포커스 주기
  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '25px',
        borderRadius: '10px',
        width: '90%',
        maxWidth: '350px',
        boxShadow: '0px 4px 15px rgba(0,0,0,0.2)'
      }}>
        <h3 style={{ margin: '0 0 10px 0', color: '#2B2B2B' }}>
          새 일정 등록 ({viewMode === 'shared' ? '공유' : '개인'})
        </h3>

        <p style={{ fontSize: '14px', color: '#666', marginBottom: '15px' }}>
          <strong>선택된 날짜:</strong> {selectedDate}
        </p>

        <input
          ref={inputRef}
          type="text"
          placeholder={viewMode === 'shared'
            ? "다른 학생들과 공유할 할 일"
            : "나만의 비밀 할 일"}
          value={todoText}
          onChange={(e) => setTodoText(e.target.value)}
          style={{
            width: '100%',
            padding: '10px',
            fontSize: '16px',
            boxSizing: 'border-box',
            marginBottom: '15px',
            borderRadius: '4px',
            border: '1px solid #E2E2E2'
          }}
          onKeyDown={(e) => e.key === 'Enter' && onAdd()}
        />

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '8px 16px',
              backgroundColor: '#F5F5F5',
              color: '#2B2B2B',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            취소
          </button>

          <button
            onClick={onAdd}
            style={{
              padding: '8px 16px',
              backgroundColor: '#F4A640',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            등록
          </button>
        </div>
      </div>
    </div>
  );
}

export default ScheduleModal;